module.exports = __webpack_public_path__ + "static/media/20.d3f3cdd4.png";